import axios from "axios";

const BASE_URL = new URL(`${window.location.origin.toString()}`);

let client = axios.create({
  baseURL: BASE_URL.protocol + "//" + BASE_URL.hostname ,
});

let setAuthToken = () => {
  client.defaults.headers.common[
      "Authorization"
      ] = `Bearer ${localStorage.getItem("CLASHMATE_ACCESS_TOKEN")}`;
  client.defaults.headers.common[
      "x-tenant"
      ] = `${localStorage.getItem("tenant") ? localStorage.getItem("tenant"): ""}`;
  return client;
};

//Request Interceptor
client.interceptors.request.use(req => {
      return req;
    }, error => {
      return Promise.reject(error);
    }
);

/**
 * Request Wrapper with default success/error actions
 */

const onSuccess = function (response) {
  console.debug("Request Successful!", response);
  return response.data;
};

const onError = function (error) {
  console.error("Request Failed:", error.config);

  if (error.response) {
    // Request was made and server responded with a status outside 2xx
    console.error("Status:", error.response.status);
    console.error("Data:", error.response.data);
    console.error("Headers:", error.response.headers);

    if (error.response.status === 401) {
      alert("Username or password is incorrect.");
      localStorage.clear();
      sessionStorage.clear();
      window.location = window.location.origin.toString();
    }

  } else if (error.request) {
    console.log(error.request)
    // Request was made but no response received
    console.error("No response received from server.Server unreachable. Please check your internet connection or try again later.");
  } else {
    // Something else happened while setting up the request
    console.error("Error Message:", error.message);
  }

  return Promise.reject(error.response || error.message);
};

const axiosInstance = function (options) {
  setAuthToken();
  return client(options).then(onSuccess).catch(onError);
};

export default axiosInstance;
